import { useUnit } from 'effector-react';
import _ from 'lodash';
import navigate from 'models/router-gate';
import { $global } from 'models/store-global';

import ModalsService from 'services/ModalsService';
import ParticipantsService from 'services/ParticipantsService';

import useResources from 'hooks/useResources';

import docs_icon from 'assets/icons/docs.svg';
import community_icon from 'assets/icons/people.svg';
import diagrams_icon from 'assets/icons/scatter_plot_24px_two_tone.svg';

import { Document } from 'types/zod/document';

const Cards = () => {
    const community = useUnit($global.map((state) => state.community));
    const { docs: documents = [], realm: participants = [] } = community || {};

    const selectedParticipant = useUnit(
        $global.map((state) =>
            state?.community?.realm?.find((p) => p.participant_id === state.temp?.selected_community_participant),
        ),
    );

    const docsForSelectedParticipant = documents.filter((document: Document) =>
        document?.ownership?.includes?.(selectedParticipant?.participant_id || -1),
    );

    const numberOfDocuments = docsForSelectedParticipant.length;

    const numberOfDiagrams = (docsForSelectedParticipant || []).filter((document: Document) =>
        ['Diagram', 'Diagram_Spouse'].includes(document.document_type_code),
    ).length;

    const noOfParticipants = participants.filter(
        (p) =>
            (p.roles || [])
                .map(({ document_id }) => _.find(documents, { document_id })?.ownership)
                .flat()
                .includes(selectedParticipant?.participant_id || -1) || ParticipantsService.isAdvisor(p),
    ).length;

    const { t } = useResources();

    return (
        <div className="cards">
            <div
                className="card documents-card"
                onClick={() => {
                    navigate('/dashboard/documents');
                }}
            >
                <div className="card-icon">
                    <img src={docs_icon} alt="documents" />
                </div>
                <div className="complete-card-header">{t('newDashboardPage.completePage.cards.myDocs')}</div>
                <div className="card-counter">
                    {numberOfDocuments !== 1 &&
                        t('newDashboardPage.completePage.cards.noOfDocuments', { number: numberOfDocuments })}
                    {numberOfDocuments === 1 && t('newDashboardPage.completePage.cards.noOfDocuments1')}
                </div>
            </div>
            <div
                className="card diagrams-card"
                onClick={() => {
                    ModalsService.showModal('DIAGRAMS_VIEWER');
                }}
            >
                <div className="card-icon">
                    <img src={diagrams_icon} alt="diagrams" />
                </div>
                <div className="complete-card-header">{t('newDashboardPage.completePage.cards.diagrams')}</div>
                <div className="card-counter">
                    {numberOfDiagrams !== 1 &&
                        t('newDashboardPage.completePage.cards.noOfDiagrams', {
                            number: numberOfDiagrams,
                        })}
                    {numberOfDiagrams === 1 && t('newDashboardPage.completePage.cards.noOfDiagrams1')}
                </div>
            </div>
            <div
                className="card community-card"
                onClick={() => {
                    navigate('/community/advocates');
                }}
            >
                <div className="card-icon">
                    <img src={community_icon} alt="community" />
                </div>
                <div className="complete-card-header">{t('newDashboardPage.completePage.cards.community')}</div>
                <div className="card-counter">
                    {noOfParticipants !== 1 &&
                        t('newDashboardPage.completePage.cards.noOfParticipants', { number: noOfParticipants })}
                    {noOfParticipants === 1 && t('newDashboardPage.completePage.cards.noOfParticipants1')}
                </div>
            </div>
        </div>
    );
};

export default Cards;
